
import { Zuweisung } from 'src/app/domain/model/zuweisung';
import { MatTableDataSource } from '@angular/material/table';

export class ZuweisungenDataSource extends MatTableDataSource<Zuweisung> {
}
